import { rest } from "msw";
export var metaHandler = [rest.get("/header/meta.json", function (req, res, ctx) {
  return res(ctx.json({
    data: {
      loggedIn: true,
      displayName: "Bob",
      clubActive: false,
      flybuysLinked: false,
      cartItemCount: 0,
      wishlistItemCount: 0,
      messageCount: 0,
      couponNotificationEnabled: true
    }
  }));
})];